<template>
  <div v-loading="loading">
    <div class="flex-between">
      <div class="title">题目信息</div>
      <el-button style="height: 100%" size="small" @click="goBack"
        >返回列表</el-button
      >
    </div>
    <el-card shadow="hover">
      <div slot="header">
        <span class="brand-color">基本信息</span>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">题目编号：</span>
          <span>{{ basicInfo.id }}</span>
        </div>
        <div class="flex-item" v-if="false">
          <span class="flex-label">题目单价：</span>
          <span>¥ {{ basicInfo.unit_price }}</span>
        </div>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">关联技能栈：</span>
          <span>{{ basicInfo.skill_name }}</span>
        </div>
        <div class="flex-item">
          <span class="flex-label">状态：</span>
          <el-tag v-if="basicInfo.status === 1" type="warning" size="medium"
            >已提交待审核</el-tag
          >
          <el-tag v-if="basicInfo.status === 2" size="medium"
            >质检通过入库</el-tag
          >
          <el-tag v-if="basicInfo.status === 3" type="danger" size="medium"
            >质检不通过</el-tag
          >
          <el-tag v-if="basicInfo.status === 4" type="danger" size="medium"
            >题目下架</el-tag
          >
          <el-tag v-if="basicInfo.status === 6" size="medium"
            >审核通过待质检</el-tag
          >
          <el-tag v-if="basicInfo.status === 7" type="danger" size="medium"
            >审核不通过</el-tag
          >
          <el-tag v-if="basicInfo.status === 9" size="medium"
            >质检通过待终审</el-tag
          >
          <el-tag v-if="basicInfo.status === 10" type="danger" size="medium"
            >题目作废</el-tag
          >
          <el-tag v-if="basicInfo.status === 11" type="danger" size="medium"
            >终审驳回</el-tag
          >
        </div>
      </div>
      <div class="flex" v-if="basicInfo.reject_reason">
        <div class="flex-item flex-reject">
          <span class="flex-reject-title">拒绝原因：</span>
          <div class="flex-reject-mark">
            <!-- <div class="column ">
              <span
                class="column-item mb-4"
                v-for="item in basicInfo.deprecate_reason_type_label"
                :key="item"
              >
                {{ item }}
              </span>
            </div> -->
            <markdown-it :md="basicInfo.reject_reason"></markdown-it>
          </div>
        </div>
      </div>
    </el-card>

    <el-card shadow="hover">
      <div slot="header" class="flex-between">
        <span class="brand-color">题目内容</span>
        <el-button
          v-if="
            basicInfo.status === 1 &&
              authPermissions.includes(
                'question.api.fuwu_admin.skill_questions.update'
              )
          "
          size="mini"
          @click="toggleEdit"
          >{{ disabled ? "修 改" : "保 存" }}</el-button
        >
        <el-button
          v-if="
            (basicInfo.status === 3 ||
              basicInfo.status === 7 ||
              basicInfo.status === 8 ||
              basicInfo.status === 11) &&
              authPermissions.includes(
                'question.api.fuwu_admin.skill_questions.update'
              )
          "
          size="mini"
          @click="toggleEdit"
          >{{ disabled ? "修 改" : "保存并提交审核" }}</el-button
        >
      </div>
      <el-form
        class="mt-12"
        label-width="140px"
        :model="topicInfo"
        :rules="topicRules"
        ref="topicInfo"
        :hide-required-asterisk="disabled"
      >
        <el-form-item
          label="题目类别："
          prop="question_type"
          :show-message="false"
        >
          <el-radio-group
            v-model="topicInfo.question_type"
            size="mini"
            :disabled="disabled"
          >
            <el-radio
              v-for="(item, index) in typeList"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="难度等级：" prop="level" :show-message="false">
          <el-radio-group
            v-model="topicInfo.level"
            size="medium"
            :disabled="disabled"
          >
            <el-radio-button :label="1">简单</el-radio-button>
            <el-radio-button :label="2">普通</el-radio-button>
            <el-radio-button :label="3">困难</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="所属知识点："
          prop="knowledge_ids"
          :show-message="false"
        >
          <el-button
            size="medium"
            @click="showSelectDialog()"
            :disabled="disabled"
            >选择知识点</el-button
          >
          <div v-for="(item, index) in selectKnowledgeArr" :key="index">
            <el-tag size="medium">{{ item.name }}</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="行业分类：">
          <el-cascader
            v-model="topicInfo.common_industries"
            :options="industryList"
            :props="optionProps"
            class="w-400"
            placeholder="请选择行业分类"
            :disabled="disabled"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="建议最长答题时间：" prop="time_max">
          <el-input-number
            v-model="topicInfo.time_max"
            label="描述文字"
            size="small"
            :disabled="disabled"
            :min="1"
          ></el-input-number>
          <span style="margin-left: 10px; margin-right: 10px"> 单位 / 秒</span>
          <el-popover
            placement="top-start"
            width="500"
            title="提示"
            trigger="hover"
            content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
          >
            <p class="popover-title">
              用户作答最长不超过的答题时长，超出时长未作答时将自动判错。请根据题目实际情况设置，一般情况下
            </p>
            <ul class="popover-list">
              <li class="popover-item">简单题目60秒</li>
              <li class="popover-item">普通题目90秒</li>
              <li class="popover-item">困难题目120秒</li>
            </ul>

            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-form-item>
        <el-form-item
          label="题目来源："
          prop="source_type"
          :show-message="false"
        >
          <el-radio-group v-model="topicInfo.source_type" :disabled="disabled">
            <el-radio
              v-for="(item, index) in sourceList"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="查看方式：">
          <el-checkbox-group v-model="topicInfo.language">
            <el-checkbox label="zh-cn" checked disabled>中文</el-checkbox>
            <el-checkbox label="en">英文</el-checkbox>
            <el-checkbox label="fr">法文</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div class="language-container">
          <div class="language-box">
            <div class="language-title">中文</div>
            <el-form-item label="题干：" prop="stem" :show-message="false">
              <Markdown
                class="w-90pc min-h-200 min-w-400"
                :value.sync="topicInfo.stem"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                :defaultOpen="disabled ? 'preview' : 'edit'"
                :disabled="disabled"
                :option="!disabled ? 'assign_topic' : 'readmodel'"
              ></Markdown>
            </el-form-item>
            <el-form-item
              v-for="(option, index) in topicInfo.options"
              :key="index"
              :label="`选项 ${index + 1}：`"
              :prop="`options[${index}].content`"
              :rules="{ required: true, trigger: 'blur' }"
              :show-message="false"
            >
              <el-radio
                v-model="topicInfo.correctIndex"
                :label="index"
                :disabled="disabled"
                >正确答案</el-radio
              >
              <div class="topic-option">
                <div class="item-float-delete">
                  <el-link
                    v-if="!disabled"
                    icon="el-icon-delete"
                    :underline="false"
                    type="danger"
                    @click="deleteOption(index)"
                  ></el-link>
                </div>
                <Markdown
                  :value.sync="option.content"
                  space="_for_kungfu_sub_project"
                  folder="fuwu"
                  :defaultOpen="disabled ? 'preview' : 'edit'"
                  :disabled="disabled"
                  :option="!disabled ? 'assign_topic' : 'readmodel'"
                  class="min-w-400 min-h-200"
                ></Markdown>
              </div>
            </el-form-item>
            <div class="option-add-btn" v-if="!disabled">
              <el-button size="medium" @click="addOption">添加选项</el-button>
            </div>
            <el-form-item label="解析：" prop="analysis" :show-message="false">
              <Markdown
                class="w-90pc min-h-200 min-w-400"
                :value.sync="topicInfo.analysis"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                :defaultOpen="disabled ? 'preview' : 'edit'"
                :disabled="disabled"
                :option="!disabled ? 'assign_topic' : 'readmodel'"
              ></Markdown>
            </el-form-item>
          </div>
          <div class="language-box" v-if="topicInfo.language.includes('en')">
            <div class="language-title">英文</div>
            <el-form-item
              prop="en_stem"
              :show-message="false"
              label-width="10px"
            >
              <Markdown
                class="w-90pc min-h-200 min-w-400"
                :value.sync="topicInfo.en_stem"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                :defaultOpen="disabled ? 'preview' : 'edit'"
                :disabled="disabled"
                :option="!disabled ? 'assign_topic' : 'readmodel'"
              ></Markdown>
            </el-form-item>
            <el-form-item
              v-for="(option, index) in topicInfo.options"
              :key="index"
              :prop="`options[${index}].content`"
              :rules="{ required: true, trigger: 'blur' }"
              :show-message="false"
              label-width="10px"
            >
              <div style="height: 40px"></div>
              <div class="topic-option">
                <Markdown
                  :value.sync="option.en_content"
                  space="_for_kungfu_sub_project"
                  folder="fuwu"
                  class="min-w-400 min-h-200"
                  :defaultOpen="disabled ? 'preview' : 'edit'"
                  :disabled="disabled"
                  :option="!disabled ? 'assign_topic' : 'readmodel'"
                ></Markdown>
              </div>
            </el-form-item>
            <div style="height: 72px" v-show="!disabled"></div>
            <el-form-item
              prop="en_analysis"
              :show-message="false"
              label-width="10px"
            >
              <Markdown
                class="w-90pc min-h-200 min-w-400"
                :value.sync="topicInfo.en_analysis"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                :defaultOpen="disabled ? 'preview' : 'edit'"
                :disabled="disabled"
                :option="!disabled ? 'assign_topic' : 'readmodel'"
              ></Markdown>
            </el-form-item>
          </div>
          <div class="language-box" v-if="topicInfo.language.includes('fr')">
            <div class="language-title">法文</div>
            <el-form-item
              prop="fr_stem"
              :show-message="false"
              label-width="10px"
            >
              <Markdown
                class="w-90pc min-h-200 min-w-400"
                :value.sync="topicInfo.fr_stem"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                :defaultOpen="disabled ? 'preview' : 'edit'"
                :disabled="disabled"
                :option="!disabled ? 'assign_topic' : 'readmodel'"
              ></Markdown>
            </el-form-item>
            <el-form-item
              v-for="(option, index) in topicInfo.options"
              :key="index"
              :prop="`options[${index}].content`"
              :rules="{ required: true, trigger: 'blur' }"
              :show-message="false"
              label-width="10px"
            >
              <div style="height: 40px"></div>
              <div class="topic-option">
                <Markdown
                  :value.sync="option.fr_content"
                  space="_for_kungfu_sub_project"
                  folder="fuwu"
                  class="min-w-400 min-h-200"
                  :defaultOpen="disabled ? 'preview' : 'edit'"
                  :disabled="disabled"
                  :option="!disabled ? 'assign_topic' : 'readmodel'"
                ></Markdown>
              </div>
            </el-form-item>
            <div style="height: 72px" v-show="!disabled"></div>
            <el-form-item
              prop="fr_analysis"
              :show-message="false"
              label-width="10px"
            >
              <Markdown
                class="w-90pc min-h-200 min-w-400"
                :value.sync="topicInfo.fr_analysis"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                :defaultOpen="disabled ? 'preview' : 'edit'"
                :disabled="disabled"
                :option="!disabled ? 'assign_topic' : 'readmodel'"
              ></Markdown>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </el-card>
    <el-backtop></el-backtop>

    <el-dialog
      title="选择知识点"
      :visible.sync="selectVisible"
      width="600px"
      :before-close="clearSelectInfo"
      center
    >
      <el-input
        placeholder="输入关键字进行过滤"
        v-model="filterText"
        size="mini"
        class="mb-12 w-49pc"
      >
      </el-input>
      <el-alert type="warning" :closable="false" class="mb-12"
        ><i class="el-icon-info"></i> 难度等级：R1-R5,
        对应关系：零基础(R1)、简单(R2)、一般(R3)、困难(R4)、非常困难(R5)<br />
        <i class="el-icon-info"></i> 掌握程度：P1-P5,
        对应关系：了解(P1)、熟悉(P2)、掌握(P3)、精通(P4)、专家(P5)<br />
        <i class="el-icon-info"></i>
        每道题目最多选择2个知识点</el-alert
      >
      <div class="dialog-tree-container" v-loading="dialogLoading">
        <el-tree
          :data="tree"
          :props="treeProps"
          node-key="id"
          :default-checked-keys="topicInfo.knowledge_ids"
          :highlight-current="true"
          :expand-on-click-node="false"
          default-expand-all
          show-checkbox
          ref="tree"
          :filter-node-method="filterNode"
          @node-click="handleNodeClick"
          @check="handleNodeCheck"
          :check-strictly="true"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span class="tree-label" :class="node.id">
              <span v-show="!disabled"
                >{{ data.text }}
                <span v-if="data.difficult_level">
                  - R{{ data.difficult_level }}
                </span>
                <span v-if="data.mastery_level">
                  - P{{ data.mastery_level }}</span
                >
              </span>
            </span>
          </span>
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearSelectInfo">取 消</el-button>
        <el-button type="primary" @click="selectKnowledgePoint"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <QuestionRepeatDialog
      :repeatDialog.sync="show"
      :dialogStep.sync="step"
      :dialogLoading.sync="submitLoading"
      :dialogInfo="showInfo"
      @fixQuestion="handleFixQuestion"
    ></QuestionRepeatDialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import skillService from "@/global/service/skill";
import kcellService from "@/global/service/kcell";
import Markdown from "@/components/Markdown";
import QuestionRepeatDialog from "@/components/QuestionRepeatDialog.vue";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
export default {
  components: {
    Markdown,
    MarkdownIt,
    QuestionRepeatDialog
  },
  data() {
    return {
      show: false,
      step: "check",
      showInfo: {},
      submitLoading: false,
      loading: true,
      disabled: true,
      dialogLoading: false,
      topicInfoBack: null,
      basicInfo: {
        id: null,
        unit_price: "",
        skill_id: null,
        skill_name: "",
        level: null,
        knowledge_ids: [],
        knowledges: [],
        status: null,
        status_label: ""
      },
      sourceList: [
        { value: 1, label: "原创" },
        { value: 2, label: "网络" },
        { value: 3, label: "翻译" },
        { value: 4, label: "购买" },
        { value: 5, label: "改编" },
        { value: 6, label: "其他" }
      ],
      typeList: [
        { value: 4, label: "场景" },
        { value: 2, label: "概念" },
        { value: 3, label: "代码" },
        { value: 1, label: "其他" }
      ],
      topicInfo: {
        level: null,
        knowledge_ids: [],
        stem: "",
        analysis: "",
        options: [],
        time_max: 60,
        correctIndex: 0,
        source_type: null,
        question_type: null,
        language: [],
        common_industries: []
      },
      topicRules: {
        level: { required: true, trigger: "blur" },
        knowledge_ids: { required: true, trigger: "blur" },
        stem: { required: true, trigger: "blur" },
        analysis: { required: true, trigger: "blur" },
        source_type: { required: true, trigger: "change" },
        question_type: { required: true, trigger: "change" }
      },
      selectVisible: false,
      filterText: "",
      tree: [
        {
          text: "",
          children: []
        }
      ],
      treeProps: {
        label: "text",
        children: "children"
      },
      treeChildren: [],
      selectKnowledgeArr: [],
      formFirstInit: true,
      formChange: false,
      knowledgeChange: false,
      industryList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
        checkStrictly: false,
        multiple: true
      }
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
    // topicInfo: {
    //   deep: true,
    //   handler() {
    //     if (this.disabled) {
    //       return;
    //     }
    //     this.formChange = true;
    //   }
    // },
    // selectKnowledgeArr: {
    //   deep: true,
    //   handler() {
    //     if (this.disabled) {
    //       return;
    //     }
    //     this.knowledgeChange = true;
    //   }
    // }
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
    this.getConst();
  },
  methods: {
    getData() {
      const id = this.$route.params.id;
      skillService
        .topicShow(id)
        .then(res => {
          let targetInfo = "";
          if (res.deprecate_reason_type_label) {
            res.deprecate_reason_type_label.forEach(item => {
              targetInfo += "* " + item + "</br> \n";
            });
          }
          if (res.reject_reason) {
            targetInfo += "* " + res.reject_reason;
          }

          this.basicInfo.reject_reason = targetInfo;
          this.basicInfo.id = res.id;
          this.basicInfo.unit_price = res.unit_price;
          this.basicInfo.skill_id = res.stack.id;
          this.basicInfo.skill_name = res.stack.name;
          this.basicInfo.status = res.status;
          this.basicInfo.status_label = res.status_label;
          this.topicInfo.level = res.level;
          const knowledge_ids = res.knowledge_points.map(
            point => point.knowledge_point_id
          );
          this.topicInfo.time_max = res.time_max;
          this.topicInfo.source_type = res.source_type;
          this.topicInfo.question_type = res.question_type;
          this.topicInfo.common_industries = res.common_industries.map(
            d => d.id
          );
          this.topicInfo.language = res.languages;
          this.topicInfo.knowledge_ids = knowledge_ids;
          this.topicInfo.stem = res.translator["zh-cn"].stem;
          this.topicInfo.en_stem = res.translator["en"]
            ? res.translator["en"].stem
            : "";
          this.topicInfo.fr_stem = res.translator["fr"]
            ? res.translator["fr"].stem
            : "";
          this.topicInfo.analysis = res.translator["zh-cn"].analysis;
          this.topicInfo.en_analysis = res.translator["en"]
            ? res.translator["en"].analysis
            : "";
          this.topicInfo.fr_analysis = res.translator["fr"]
            ? res.translator["fr"].analysis
            : "";
          res.options.forEach((data, index) => {
            if (data.correct) this.topicInfo.correctIndex = index;
            this.topicInfo.options[index] = {
              id: data.id,
              content: data.translator["zh-cn"].option,
              en_content: data.translator["en"]
                ? data.translator["en"].option
                : "",
              fr_content: data.translator["fr"]
                ? data.translator["fr"].option
                : ""
            };
          });
          this.topicInfoBack = JSON.stringify(this.topicInfo);
          return {
            id: res.stack.id,
            ids: knowledge_ids
          };
        })
        .then(obj => {
          skillService
            .skillKnowledge(obj.id)
            .then(res => {
              this.treeChildren = res;
              this.getKnowledgeArr(obj.ids, this.treeChildren);
            })
            .finally(() => {
              this.loading = false;
            });
        });
    },
    getConst() {
      kcellService.kcellIndustry().then(res => {
        this.industryList = res;
      });
    },
    showSelectDialog() {
      this.selectVisible = true;
      this.dialogLoading = true;
      skillService
        .skillKnowledge(this.basicInfo.skill_id)
        .then(res => {
          this.tree[0].text = this.basicInfo.skill_name;
          this.tree[0].children = res;
          this.treeChildren = res;
          this.setDisabled(this.tree);
        })
        .finally(() => {
          this.dialogLoading = false;
          this.$refs["tree"].setCheckedKeys(this.topicInfo.knowledge_ids);
        });
    },
    setDisabled(arr) {
      arr.forEach(data => {
        if (data.children.length) {
          data.disabled = true;
          this.setDisabled(data.children);
        }
      });
      return arr;
    },
    selectKnowledgePoint() {
      const selected = this.$refs["tree"].getCheckedNodes(true);
      if (selected.length === 0) {
        this.$message.error("请选择知识点");
        return;
      }
      this.topicInfo.knowledge_ids = selected.map(data => data.id);
      this.getKnowledgeArr(this.topicInfo.knowledge_ids, this.treeChildren);
      this.clearSelectInfo();
    },
    getKnowledgeArr(ids = [], arr, result = [], parentName) {
      arr.forEach(item => {
        let name = parentName
          ? `${parentName} => ${item.text}`
          : `${this.basicInfo.skill_name} => ${item.text}`;
        if (ids.includes(item.id)) {
          result.push({
            id: item.id,
            name
          });
        }
        if (item.children.length) {
          this.getKnowledgeArr(ids, item.children, result, name);
        }
      });
      this.selectKnowledgeArr = result;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.text.indexOf(value) !== -1;
    },
    clearSelectInfo() {
      this.selectVisible = false;
      this.tree = [{ text: "", children: [] }];
    },
    handleNodeClick(data) {
      if (data.children.length !== 0) return;
      const checked = this.$refs["tree"].getCheckedKeys();
      const index = checked.indexOf(data.id);
      if (index === -1) {
        if (checked.length >= 2) {
          return this.$message.error("您最多选择两个知识点");
        }
        checked.push(data.id);
        this.$refs["tree"].setCheckedKeys(checked);
      } else {
        checked.splice(index, 1);
        this.$refs["tree"].setCheckedKeys(checked);
      }
    },
    handleNodeCheck(data, e) {
      const arr = this.$refs["tree"].getCheckedKeys();
      if (arr.length > 2) {
        const index = arr.indexOf(data.id);
        arr.splice(index, 1);
        e.checkedKeys.splice(index, 1);
        e.checkedNodes.splice(index, 1);
        this.$refs["tree"].setCheckedKeys(arr);
        return this.$message.error("您最多选择两个知识点");
      }
    },
    goBack() {
      this.$router.push({ name: "QuestionSkillMySelf" });
    },
    addOption() {
      this.topicInfo.options.push({
        content: "",
        fr_content: "",
        en_content: ""
      });
    },
    deleteOption(index) {
      if (this.topicInfo.options.length === 2) {
        this.$message.error("选项数量不得少于两个");
        return;
      } else {
        this.topicInfo.options.splice(index, 1);
      }
    },
    toggleEdit() {
      if (this.disabled) {
        this.disabled = false;
      } else {
        this.upDateInfo();
      }
    },
    upDateInfo() {
      if (this.topicInfoBack == JSON.stringify(this.topicInfo)) {
        this.$message.info("您未修改任何信息");
        this.disabled = true;
        return;
      }
      // if (!this.formChange && !this.knowledgeChange) {
      //   this.disabled = true;
      //   return this.$message.info("您未修改任何信息");
      // }
      if (this.basicInfo.skill_name == null) {
        this.$message.error("技能栈名称为空，请联系管理员");
        return;
      }
      if (this.loading) return;
      this.$refs["topicInfo"].validate(val => {
        if (!val) {
          this.$message.error("缺少必要参数");
          return;
        }
        let options = [];
        let translator = {};
        if (
          this.topicInfo.language.length == 2 &&
          this.topicInfo.language.includes("en")
        ) {
          const valid = this.topicInfo.options.every(data => data.en_content);
          if (!valid) {
            return this.$message.error("英文选项未填写完整");
          }
          options = this.topicInfo.options.map(data => {
            return {
              id: data.id,
              correct: false,
              translator: {
                "zh-cn": {
                  option: data.content
                },
                en: {
                  option: data.en_content
                }
              }
            };
          });
          translator = {
            "zh-cn": {
              stem: this.topicInfo.stem,
              analysis: this.topicInfo.analysis
            },
            en: {
              stem: this.topicInfo.en_stem,
              analysis: this.topicInfo.en_analysis
            }
          };
        } else if (
          this.topicInfo.language.length == 2 &&
          this.topicInfo.language.includes("fr")
        ) {
          const valid = this.topicInfo.options.every(data => data.fr_content);
          if (!valid) {
            return this.$message.error("法文选项未填写完整");
          }
          options = this.topicInfo.options.map(data => {
            return {
              id: data.id,
              correct: false,
              translator: {
                "zh-cn": {
                  option: data.content
                },
                fr: {
                  option: data.fr_content
                }
              }
            };
          });
          translator = {
            "zh-cn": {
              stem: this.topicInfo.stem,
              analysis: this.topicInfo.analysis
            },
            fr: {
              stem: this.topicInfo.fr_stem,
              analysis: this.topicInfo.fr_analysis
            }
          };
        } else if (this.topicInfo.language.length == 3) {
          const valid = this.topicInfo.options.every(
            data => data.fr_content && data.en_content
          );
          if (!valid) {
            return this.$message.error("英文或法文选项未填写完整");
          }
          options = this.topicInfo.options.map(data => {
            return {
              id: data.id,
              correct: false,
              translator: {
                "zh-cn": {
                  option: data.content
                },
                en: {
                  option: data.en_content
                },
                fr: {
                  option: data.fr_content
                }
              }
            };
          });
          translator = {
            "zh-cn": {
              stem: this.topicInfo.stem,
              analysis: this.topicInfo.analysis
            },
            en: {
              stem: this.topicInfo.en_stem,
              analysis: this.topicInfo.en_analysis
            },
            fr: {
              stem: this.topicInfo.fr_stem,
              analysis: this.topicInfo.fr_analysis
            }
          };
        } else if (this.topicInfo.language.length == 1) {
          options = this.topicInfo.options.map(data => {
            return {
              id: data.id,
              correct: false,
              translator: {
                "zh-cn": {
                  option: data.content
                }
              }
            };
          });
          translator = {
            "zh-cn": {
              stem: this.topicInfo.stem,
              analysis: this.topicInfo.analysis
            }
          };
        }
        const id = this.$route.params.id;
        options[this.topicInfo.correctIndex].correct = true;
        const params = {
          level: this.topicInfo.level,
          knowledge_points: this.selectKnowledgeArr,
          source_type: this.topicInfo.source_type,
          question_type: this.topicInfo.question_type,
          time_max: this.topicInfo.time_max,
          languages: this.topicInfo.language,
          common_industries: this.topicInfo.common_industries,
          translator,
          options
        };
        this.loading = true;
        this.show = true;
        this.submitLoading = true;
        skillService
          .topicEdit(id, params)
          .then(res => {
            this.step = "pass";
            this.submitLoading = false;
            if (res.question_id) {
              setTimeout(() => {
                this.basicInfo.status = 1;
                this.disabled = true;
                this.show = false;
                this.step = "check";
                this.$message.success("保存成功");
              }, 1500);
            } else {
              setTimeout(() => {
                this.step = "reject";
                this.showInfo = res;
                this.submitLoading = false;
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    handleFixQuestion() {
      this.show = false;
      this.step = "check";
      this.showInfo = {};
    }
  }
};
</script>

<style lang="less" scoped>
.el-card {
  margin-bottom: 30px;
  overflow-x: scroll;
}
.flex {
  display: flex;
  margin-bottom: 12px;
  font-size: 14px;
  .flex-item {
    flex: 1;
  }
  .flex-label {
    display: inline-block;
    width: 100px;
    text-align: right;
  }
}
.topic-option {
  position: relative;
  width: 90%;
  .item-float-delete {
    z-index: 1501;
    position: absolute;
    bottom: 10px;
    right: 12px;
    height: 0;
    overflow: hidden;
    .el-link {
      font-size: 16px;
    }
  }
  &:hover .item-float-delete {
    height: 28px;
  }
}
/deep/.el-dialog__body {
  padding-bottom: 0px !important;
}
.dialog-tree-container {
  padding: 0 20px;
  max-height: 340px;
  overflow: scroll;
}
.option-add-btn {
  margin-left: 120px;
  margin-bottom: 36px;
}

.language-container {
  display: flex;
}
.language-box {
  .language-title {
    text-align: center;
    margin-bottom: 20px;
  }
}
.flex-reject {
  display: flex;
  .flex-reject-title {
    // flex: 1;
    width: 100px;
    text-align: right;
  }
  .flex-reject-mark {
    width: calc(100% - 100px);
    max-height: 100px;
    overflow-x: auto;
    line-height: 14px;
  }
}
</style>
